export enum PlanNameEnum {
  Standard = 'Standard',
  Plus = 'Plus',
  Premium = 'Premium',
}
export enum PeriodicityTypeEnum {
  monthly = 'monthly',
  daily = 'daily',
  yearly = 'yearly',
  weekly = 'weekly',
}

export interface IPlan {
  id: number;
  grace_days: number;
  name: string | PlanNameEnum;
  display_name?: string;
  periodicity: number;
  periodicity_type: string | PeriodicityTypeEnum;
  deleted_at: any;
  created_at: string;
  updated_at: string;
  razorpay_plan: RazorpayPlan;
  features: Feature[];
  rules: Rule[];
  subscription_offers?: ISubscriptionOffer[];
}

export interface ISubscriptionOffer {
  id: number;
  name: string;
  code: string;
  razorpay_offer_id?: string;
  description?: string | null;
  payment_account?: string;
  payment_method?: string;
  discount_type?: 'percentage' | 'flat' | string;
  discount_value: number;
  max_discount_amount?: number | null;
  min_plan_amount?: number | null;
  plan_id?: number;
  start_at?: string | null;
  end_at?: string | null;
  usage_limit?: number | null;
  times_used?: number;
  usage_limit_per_user?: number;
  is_active?: boolean;
  metadata?: any;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
}

export type ISubscriptionType = 'platform' | 'product';
export interface IPlansParams {
  type: ISubscriptionType;
  group_name: 'main' | 'affiliate';
}

export interface IStartSubscriptionBody {
  id?: number;
  plan_id?: number;
  change?: boolean;
  immediate?: boolean;
  discount?: boolean;
  order_id?: number;
  subscription_id?: number;
  mode?: 'auto' | 'manual';
  offer_id?: number;
  payment_method?: string;
  gst_number?: string;
}

export interface IVerifySubscriptionPayload {
  rp_payment_id: string;
  razorpay_subscription_id?: string;
}

export interface RazorpayPlan {
  id: number;
  plan_id: number;
  razorpay_plan_id: string;
  currency: string;
  amount: number;
  interval_unit: string;
  interval_count: number;
  max_payment_cycle: number;
  created_at: string;
  updated_at: string;
  deleted_at: any;
  discountable: number;
  payment_account?: 'razorpay' | 'razorpay_2' | string;
}

export interface Feature {
  id: number;
  name: string;
  consumable: number;
  quota: number;
  postpaid: number;
  periodicity: number;
  periodicity_type: string;
  deleted_at: any;
  created_at: string;
  updated_at: string;
  pivot: Pivot;
  available_quantity: number;
  total_quantity: number;
  used_quantity: number;
  remaining_quantity: number;
  next_unload_at: string;
}

export interface Pivot {
  plan_id: number;
  feature_id: number;
  charges: string;
}

export interface Rule {
  id: number;
  code: string;
  description: string;
  digital: number;
  physical: number;
  bundle: number;
  has_expiry: number;
  active: number;
  created_at: string;
  updated_at: string;
  deleted_at: any;
  pivot: Pivot2;
}

export interface Pivot2 {
  plan_id: number;
  rule_id: number;
}

export enum SubscriptionParametersEnum {
  TOTAL_SUBSCRIPTION_DURATION = 'Total Subscription Duration',
  BOOKS_QUANTITY = 'Books Quantity',
  DIGITAL_BOOKS = 'Digital Books',
  HARDCOVER_BOOKS = 'Hardcover Books',
  HIDDEN_CHARGES = 'Hidden Charges',
  SHIPPING_CHARGES = 'Shipping Charges',
  APP_AND_WEB_FRIENDLY = 'App & Web Friendly',
}

export interface Razorpay {
  order_id: string;
  subscription_id: any;
  short_url: any;
}
export interface IStartSubscription {
  data: Data;
  razorpay_subscription: RazorpaySubscription;
  redirect_url: string;
  mode: 'manual' | 'auto';
  status: string;
  subscription_id: number;
  plan_id: number;
  amount_paise: number;
  currency: string;
  razorpay: Razorpay;
  payment_account: 'razorpay_2';
  id: string;
}

export interface Data {
  razorpay_subscription_id: string;
  razorpay_plan_id: string;
  user_id: number;
  plan_id: number;
  status: string;
  subscription_id: any;
  quantity: number;
  charge_at: any;
  start_at: any;
  end_at: any;
  expire_by: any;
  ended_at: any;
  short_url: string;
  updated_at: string;
  created_at: string;
  id: number;
}

export type RazorpaySubscription = object;

export interface ISubscribeProductBody {
  product_id: number;
  address_id: number;
}

export interface IUserConsumable {
  features: Feature[];
  active_sub: ActiveSub;
  rules: Rule3[];
  feature_consumables_list: FeatureConsumablesList[][];
}

export interface ActiveSub {
  id: number;
  plan_id: number;
  canceled_at: any;
  expired_at: string;
  grace_days_ended_at: string;
  started_at: string;
  suppressed_at: any;
  was_switched: number;
  deleted_at: any;
  created_at: string;
  updated_at: string;
  subscriber_type: string;
  subscriber_id: number;
  snapshot: Snapshot;
  plan: IPlan;
}

export interface Snapshot {
  rules: Rule[];
  plan_id: number;
  features: Feature2[];
  plan_name: string;
}

export interface Rule {
  code: string;
  active: number;
  bundle: number;
  digital: number;
  rule_id: number;
  physical: number;
  has_expiry: number;
  description: string;
}

export interface Feature2 {
  name: string;
  charges: string;
  feature_id: number;
  periodicity: number;
  periodicity_type: string;
}

export interface Rule2 {
  id: number;
  code: string;
  description: string;
  digital: number;
  physical: number;
  bundle: number;
  has_expiry: number;
  active: number;
  created_at: string;
  updated_at: string;
  deleted_at: any;
  pivot: Pivot;
}

export interface Pivot {
  plan_id: number;
  rule_id: number;
}

export interface Rule3 {
  id: number;
  code: string;
  description: string;
  digital: number;
  physical: number;
  bundle: number;
  has_expiry: number;
  active: number;
}

export interface FeatureConsumablesList {
  id: number;
  user_id: number;
  plan_id: number;
  subscription_id: number;
  feature_id: number;
  quantity: number;
  used_quantity: number;
  is_used: boolean;
  unload_at: string;
  used_at?: string;
  unique_hash: string;
  created_at: string;
  updated_at: string;
  feature: Feature3;
}

export interface Feature3 {
  id: number;
  name: string;
  consumable: number;
  quota: number;
  postpaid: number;
  periodicity: number;
  periodicity_type: string;
  deleted_at: any;
  created_at: string;
  updated_at: string;
}

export interface IPlansOffer {
  offer_available: boolean;
  status: string;
  message: string;
  order: Order;
  plan: Plan;
  plan_features: PlanFeature[];
  type: 'cod' | 'prepaid';
}

export interface Order {
  id: number;
  amount_paid: number;
  discount_applied: number;
  counts: Counts;
  products: Product[];
}

export interface Counts {
  hardcover: number;
  digital: number;
  total: number;
}

export interface Product {
  order_detail_id: number;
  product_id: number;
  name: string;
  type: string;
  quantity: number;
  thumbnail_image: string;
}

export interface Plan {
  id: number;
  name: string;
  details: Details;
  plan_price: number;
  plan_discount: number;
  plan_discounted_price: number;
  upgrade_price: number;
}

export interface Details {
  id: number;
  grace_days: number;
  name: string;
  periodicity: number;
  periodicity_type: string;
  deleted_at: any;
  created_at: string;
  updated_at: string;
  razorpay_plan: RazorpayPlan;
  features: Feature[];
  rules: Rule[];
}

export interface RazorpayPlan {
  id: number;
  plan_id: number;
  razorpay_plan_id: string;
  currency: string;
  amount: number;
  interval_unit: string;
  interval_count: number;
  max_payment_cycle: number;
  created_at: string;
  updated_at: string;
  deleted_at: any;
}

export interface Feature {
  id: number;
  name: string;
  consumable: number;
  quota: number;
  postpaid: number;
  periodicity: number;
  periodicity_type: string;
  deleted_at: any;
  created_at: string;
  updated_at: string;
  pivot: Pivot;
}

export interface Pivot {
  plan_id: number;
  feature_id: number;
  charges: string;
}

export interface PlanFeature {
  id: number;
  name: string;
  charges: number;
  periodicity: number;
  periodicity_type: string;
}

export interface IGetSubscriptionInfo {
  user_email: string;
  user_id: number;
  user_name: string;
  amount: number;
  rzp_order_id: string;
  status: string;
  plan_amount: number;
  discount: number;
  currency: string;
  currency_symbol: string;
  payment_account: 'razorpay_2';
  mode?: 'auto' | 'manual';
  rzp_subscription_id: string;
}

export interface IProductAccessCheck {
  can_access: boolean;
  is_purchased: boolean;
  reason: string;
  user_product: any;
}

export interface IVerifyResponse {
  success: boolean;
  code: string;
  message: string;
  retry: boolean;
  retry_after: number;
}
